import React from 'react';
import { HotelCounter } from 'src/components/HotelCounter';
import type { SearchType } from 'src/types/search';
import Sorting from '../Sorting';
import styles from './SubtitleContainer.module.css';

type SubtitleContainerProps = {
  searchType: SearchType;
  hotelsCount: number;
  awaitFiltration: boolean;
  isMobile?: boolean;
};

const SubtitleContainer = ({
  searchType,
  hotelsCount,
  awaitFiltration,
  isMobile = false,
}: SubtitleContainerProps) => {
  const containerClass = isMobile
    ? `${styles.subtitleContainer} ${styles.subtitleContainerMobile}`
    : styles.subtitleContainer;

  return (
    <div className={containerClass}>
      <Sorting />
      <HotelCounter
        hotelCounter={hotelsCount}
        searchType={searchType}
        loading={awaitFiltration}
      />
    </div>
  );
};

export default SubtitleContainer;
